import React, { Component } from 'react';
// import PropTypes from 'prop-types';

import '../styles/App.css';
import '../styles/CardSkill.css';

export default class CardSkill extends Component {

  render() {
    const { skills } = this.props;
    const { img, name } = skills;
    return (
      <section className="container-cardSkill">
        <img src={img} alt={`Icone da Skill ${name}`} />
        <h4 className="title-skill">{name}</h4>

      </section>
    )
  };
};
